import { ReactNode, useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IconArrowUp } from "../../icons/IconArrowUp/IconArrowUp";
import { IconArrowDropdown } from "../../icons/IconArrowDropdown/IconArrowDropdown";
import LeafTileDivider from "../LeafTileDivider/LeafTileDivider";
import "./LeafCollapsibleSection.scss";
import { Button } from "../../components/Button/Button";

export interface Props {
  isExpanded?: boolean;
  titleExpand?: string;
  titleCollapse?: string;
  children?: ReactNode;
  onClickFn?: Function;
  theme?: "basic" | "modern" | "custom";
  prefix?: ReactNode;
  mainContent?: ReactNode;
  headerValue?: ReactNode;
  closeButtonPosition?: "top" | "bottom";
  useLocalState?: boolean;
  id?: string;
}

export const LeafCollapsibleSection = ({
  isExpanded = false,
  titleExpand = "Expand",
  titleCollapse = "Collapse",
  onClickFn,
  children,
  closeButtonPosition = "top",
  theme = "basic",
  prefix = <></>,
  mainContent = <></>,
  headerValue = <></>,
  useLocalState = true,
  id = "",
}: Props) => {
  const { t } = useTranslation(["leafCollapsibleSection"]);

  const [expanded, setExpanded] = useState(false);
  const _expanded = useLocalState ? expanded : isExpanded;

  useEffect(() => {
    // use a hook to write prop to state will cause the component to re-render unexpected
    // hence add a check for use case that do not wanted to use local state and use prop value directly to avoid local state being updated
    if (useLocalState === true) {
      setExpanded(isExpanded);
    }
  }, [isExpanded, useLocalState]);

  const toggleExpandedContent = () => {
    if (useLocalState === true) {
      setExpanded(!expanded);
    }

    if (onClickFn) {
      onClickFn(!isExpanded, id);
    }
  };

  return (
    <div className={"Lcs Lcs__" + (_expanded ? "expanded" : "collapsed")}>
      <div>
        {_expanded && closeButtonPosition === "bottom" && <div className="Lcs__children">{children}</div>}
        <div className={`Lcs__header--${theme}`}>
          <Button
            aria-label={_expanded ? titleCollapse : titleExpand}
            aria-expanded={_expanded}
            className={`${_expanded ? "Lcs__collapse-message" : "Lcs__expand-message"} ${theme}`}
            onClick={toggleExpandedContent}
          >
            <span className="leaf-selector__prefix-icon">{prefix}</span>
            <span className={_expanded ? `Lcs__message-text  ${theme}` : ""}>
              {_expanded ? titleCollapse : titleExpand}
            </span>
            <span className="Lcs__message-icon">
              {_expanded ? <IconArrowUp backgroundClass={"black"} /> : <IconArrowDropdown backgroundClass={"black"} />}
            </span>
          </Button>
          <div className="leaf-selector__header-value">{headerValue}</div>
        </div>
        {_expanded && theme === "basic" && <LeafTileDivider />}
        {mainContent}
        {_expanded && closeButtonPosition === "top" && <div className="Lcs__children">{children}</div>}
      </div>
    </div>
  );
};
